import AccordionCardWidget from '@/components/base/AccordionCardWidget.vue'
import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import CreateNewCustomerServiceCRMContact
  from "@/components/dashboard/customer-service/components/CreateNewCustomerServiceCRMContact.vue";
import MemberAccountsGrid from "@/components/dashboard/customer-service/components/MemberAccountsGrid.vue";
import SearchEmployer from "@/components/dashboard/customer-service/components/SearchEmployer.vue";
import SearchMember from "@/components/dashboard/customer-service/components/SearchMember.vue";
import TotalSubSectionComponent from "@/components/dashboard/lobby/sections/TotalSubSection.component.vue";
import BarChartsWidget from "@/components/widgets/BarChartsWidget.vue";
import DoughnutChartWidget from "@/components/widgets/DoughnutChartWidget.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {CrmFilterType} from "@/models/CrmFilterType";
import {TotalSection} from "@/models/LobbyDataResponse.model";
import {EmployerCRMDetails, MemberCRMDetails} from "@/store/modules/customerService";
import {GridColumn} from "@payroll/grid-widget/src/models/GridColumn";
import {KeyValuePair} from "@payroll/optimus-common";
import Component from 'vue-class-component'
import {Action, Mutation} from "vuex-class";


@Component({
  components: {
    DoughnutChartWidget,
    BarChartsWidget,
    SearchMember,
    SearchEmployer,
    AccordionCardWidget,
    MemberAccountsGrid,
    CreateNewCustomerServiceCRMContact,
    TotalSubSectionComponent
  }
})
export default class CustomerServiceComponent extends AfterFetchComponent {
  @Action('getAllCRMDepartments', StoreNamespace.CUSTOMER_SERVICE) getAllCRMDepartments: any;
  @Action('getMemberDetails', StoreNamespace.CUSTOMER_SERVICE) getMemberDetails: any;
  @Action('getEmployerDetails', StoreNamespace.CUSTOMER_SERVICE) getEmployerDetails: any;
  @Action('getCustomerServiceCRMGroup', StoreNamespace.CUSTOMER_SERVICE) getCustomerServiceCRMGroup: any;
  @Action('getDistributionOfCRMInquiriesPaiChartData', StoreNamespace.CUSTOMER_SERVICE) getDistributionOfCRMInquiriesPaiChartData: any;
  @Action('getCRMInquiriesByDateAndDepartmentBarData', StoreNamespace.CUSTOMER_SERVICE) getCRMInquiriesByDateAndDepartmentBarData: any;
  @Action('getCRMInquiriesByDateAndArrivalSubjectBarData', StoreNamespace.CUSTOMER_SERVICE) getCRMInquiriesByDateAndArrivalSubjectBarData: any;
  @Mutation('setReferralStatusLobby', StoreNamespace.CUSTOMER_SERVICE) private setReferralStatusLobby: any;


  private showAddNewContactForCustomerService: boolean = false
  private loadingArrivalSubjectsBarData: boolean = false
  private selectedTotalSectionItem: string = ""
  private selectedTotalSectionId: any
  private memberAccounts: any[] | undefined = []
  private memberCRMDetails: MemberCRMDetails | null = null;
  private employerCRMDetails: EmployerCRMDetails | null = null;
  private showPaiChart : boolean = false
  private showCRMInquiriesByDateAndDepartmentBarData : boolean = false
  private showCRMInquiriesByDateAndArrivalSubjectBarData : boolean = false
  private crmInquiriesByDateAndDepartmentBarDataMaxValue: number = 10;
  private crmInquiriesByDateAndArrivalSubjectBarDataMaxValue: number = 10;
  private crmFilterType : CrmFilterType | null = null

  private departments: KeyValuePair[] = []
  private selectedDepartment: any = null;
  private currentDate = new Date()

  arrivalSubjectBarDataRequest: any = {
    department: null,
    startDate: new Date(this.currentDate.setMonth(this.currentDate.getMonth() - 6)),
    endDate: new Date()
  }

  paiData = {
    chartLegendId: '',
    chartData: {
      labelPrefix: "",
      labels: [],
      datasets: [],
    },
  };

  crmInquiriesByDateAndDepartmentBarData = {
    labels: [],
    datasets: [
    ],
  }

  crmInquiriesByDateAndArrivalSubjectBarData = {
    labels: [],
    datasets: [
    ],
  }

  private totalSectionList: TotalSection[] = []

  private totalSectionData = {
    hasMore: false,
    resultCount: 1,
    results: []
  }

  private columns: GridColumn[] = [];

  mounted() {
    this.initColumns()

    this.getAllCRMDepartments({
      requestorCallback: this
    })

    this.getCustomerServiceCRMGroup({
      requestorCallback: this
    })

    this.getDistributionOfCRMInquiriesPaiChartData({
      requestorCallback: this
    })

    this.getCRMInquiriesByDateAndDepartmentBarData({
      requestorCallback: this
    })

    this.getCRMInquiriesByDateAndArrivalSubjectBarData({
      requestorCallback: this,
      requestBody: this.arrivalSubjectBarDataRequest
    })
  }

  created() {
    this.crmFilterType = null;
  }

  private initColumns(): void {
    this.columns.push({property: 'idNumber', header: 'id_number', hideSorting: true})
    this.columns.push({property: 'name', header: 'name', hideSorting: true})
    this.columns.push({property: 'creationDate', header: 'customerService.creationDate', hideSorting: true})
    this.columns.push({property: 'subject', header: 'customerService.subjectOfAppeal', hideSorting: true})
    this.columns.push({
      property: 'serviceRepresentativeName',
      header: 'customerService.serviceRepresentativeName',
      hideSorting: true
    })
  }

  private onAddNewContact() {
    this.showAddNewContactForCustomerService = true
  }

  private onCloseAddNewContact() {
    this.showAddNewContactForCustomerService = false
    this.memberCRMDetails = null
    this.employerCRMDetails = null
    this.crmFilterType = null;
  }

  private onCloseSuccessAddingNewContact() {
    this.totalSectionList = []
    this.showCRMInquiriesByDateAndDepartmentBarData = false
    this.showPaiChart = false

    this.getCustomerServiceCRMGroup({
      requestorCallback: this
    })

    this.getDistributionOfCRMInquiriesPaiChartData({
      requestorCallback: this
    })

    this.getCRMInquiriesByDateAndDepartmentBarData({
      requestorCallback: this
    })

    this.onCloseAddNewContact();
    this.showSuccessPopupMessage('customerService.popup.successMessage')
  }

  private onSelectedMember(member: any) {
    this.crmFilterType = CrmFilterType.MEMBER

    this.getMemberDetails({
      pathVariable: member.id,
      requestorCallback: this
    })
  }

  private onClickAllReferralStatus() {
    this.setReferralStatusLobby(this.selectedTotalSectionItem);
    this.$router.push({name: 'concentration-of-inquiries'})
  }

  private onSelectedEmployer(employer: any) {
    this.crmFilterType = CrmFilterType.EMPLOYER

    this.getEmployerDetails({
      pathVariable: employer.id,
      requestorCallback: this
    })
  }


  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'getMemberDetails':
        this.memberCRMDetails = data;
        this.memberAccounts = []
        if (this.memberCRMDetails) {
          this.memberAccounts = this.memberCRMDetails.accountsList
        }
        break;
      case 'crmConfigurationManagement/getAllCRMDepartments':
        this.departments = data

        break;
      case 'getEmployerDetails':
        this.employerCRMDetails = data
        break;
      case 'getCustomerServiceCRMGroup':
        this.totalSectionList = data.totalModels;
        this.totalSectionData = data.referralStatusValues;
        if (this.totalSectionList.length > 0) {
          this.selectedTotalSectionItem = ""

          for (let totalSection of this.totalSectionList) {
            if (totalSection.value > 0) {
              this.selectedTotalSectionItem = totalSection.header
              this.onLinkClick(totalSection);
              return
            }
          }

          this.selectedTotalSectionItem = this.totalSectionList[0].header
          this.onLinkClick(this.totalSectionList[0]);
        }
        break;
      case 'getDistributionOfCRMInquiriesPaiChartData':
        this.paiData = data.paiData
        this.showPaiChart = true
        break;
      case 'getCRMInquiriesByDateAndDepartmentBarData':
        this.crmInquiriesByDateAndDepartmentBarData = data.barData
        this.crmInquiriesByDateAndDepartmentBarDataMaxValue = data.maxValue + 1
        this.showCRMInquiriesByDateAndDepartmentBarData = true
        break;
      case 'getCRMInquiriesByDateAndArrivalSubjectBarData':
        this.loadingArrivalSubjectsBarData = false
        this.crmInquiriesByDateAndArrivalSubjectBarData = data.barData
        this.crmInquiriesByDateAndArrivalSubjectBarDataMaxValue = data.maxValue + 1
        this.showCRMInquiriesByDateAndArrivalSubjectBarData = true
        break;
    }
  }

  private onLinkClick(total: any) {
    this.selectedTotalSectionItem = total.header
    this.selectedTotalSectionId = total.id

    this.totalSectionData.results = []
    this.totalSectionData.resultCount = 1;

    // @ts-ignore
    if(this.totalSectionData[total.id]) {
      // @ts-ignore
      this.totalSectionData.resultCount = this.totalSectionData[total.id].length

      // @ts-ignore
      this.totalSectionData.results = this.totalSectionData[total.id]
    }

    this.$emit('successResults', this.totalSectionData)
  }

  private showSuccessPopupMessage(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  handleGetArrivalSubjectBarData() {
    console.log("window 1", window.screenY)

    this.loadingArrivalSubjectsBarData = true

    this.getCRMInquiriesByDateAndArrivalSubjectBarData({
      requestorCallback: this,
      requestBody: this.arrivalSubjectBarDataRequest
    })
  }

  get getSumOfTotalSubjectBarDataValues() {
    let totalSum = 0

    return this.crmInquiriesByDateAndArrivalSubjectBarData.datasets.reduce((acc: any, dataset: any) => {
      const sum = dataset.data && Array.isArray(dataset.data)
        ? dataset.data.reduce((sum: any, value: any) => sum + (value || 0), 0)
        : 0;

      totalSum += sum

      return totalSum
    }, 0);
  }
};